// Injected before page load. Scans every added DOM node for the document JSON
// pattern so messages are caught whether the chat panel is open or closed.
// Uses string search + brace matching instead of regex to avoid escaping issues
// in template literals and WebView injection.
export const getWherebyInjectedJS = (openChatLabel: string) => `
(function() {
  var seenIds = new Set();
  var OPEN_CHAT_LABEL = ${JSON.stringify(openChatLabel)};

  function relabelOpenChatControl(root) {
    var candidates = root.querySelectorAll('[aria-label], [title]');
    for (var i = 0; i < candidates.length; i++) {
      var el = candidates[i];
      var aria = el.getAttribute('aria-label');
      var title = el.getAttribute('title');
      if (aria && /^open chat$/i.test(aria.trim())) el.setAttribute('aria-label', OPEN_CHAT_LABEL);
      if (title && /^open chat$/i.test(title.trim())) el.setAttribute('title', OPEN_CHAT_LABEL);
    }
    var walker = document.createTreeWalker(root, 4);
    var n;
    while ((n = walker.nextNode())) {
      if ((n.textContent || '').trim().toLowerCase() === 'open chat') {
        n.textContent = OPEN_CHAT_LABEL;
      }
    }
  }

  function hideAttachmentControls(root) {
    var fileInputs = root.querySelectorAll('input[type="file"]');
    for (var i = 0; i < fileInputs.length; i++) {
      var input = fileInputs[i];
      input.disabled = true;
      input.style.display = 'none';
      var btn = input.closest('button');
      if (btn) btn.style.display = 'none';
    }
    var labeled = root.querySelectorAll('[aria-label], [title]');
    for (var j = 0; j < labeled.length; j++) {
      var el = labeled[j];
      var label = ((el.getAttribute('aria-label') || '') + ' ' + (el.getAttribute('title') || '')).toLowerCase();
      if (label.indexOf('attach') !== -1) {
        el.style.display = 'none';
      }
    }
  }

  function fixSidebarOverflow(root) {
    var sidebars = root.querySelectorAll('[class*="_sidebarContainer_"]');
    for (var i = 0; i < sidebars.length; i++) {
      var sidebar = sidebars[i];
      var rect = sidebar.getBoundingClientRect();
      var overflow = Math.round(rect.bottom - window.innerHeight);
      if (overflow > 0 && sidebar.dataset.overflowFix !== String(overflow)) {
        sidebar.style.setProperty('transform', 'translateY(-' + overflow + 'px)', 'important');
        sidebar.dataset.overflowFix = String(overflow);
      }
    }
  }

  function patchWherebyUi(root) {
    try {
      relabelOpenChatControl(root);
      hideAttachmentControls(root);
      fixSidebarOverflow(root);
    } catch (e) {}
  }

  function extractDocumentJson(text) {
    var idx = text.indexOf('"type":"document"');
    if (idx === -1) idx = text.indexOf('"type": "document"');
    if (idx === -1) return null;
    var start = text.lastIndexOf('{', idx);
    if (start === -1) return null;
    var depth = 0;
    for (var i = start; i < text.length; i++) {
      if (text[i] === '{') depth++;
      else if (text[i] === '}') {
        depth--;
        if (depth === 0) {
          try {
            var obj = JSON.parse(text.slice(start, i + 1));
            if (obj && obj.type === 'document' && obj.documentId) return obj;
          } catch(e) {}
          break;
        }
      }
    }
    return null;
  }

  function replaceJsonTextInNode(root, doc) {
    var needle1 = '"type":"document"';
    var needle2 = '"type": "document"';

    function replaceNode(n) {
      var t = n.textContent || '';
      if (t.indexOf(needle1) === -1 && t.indexOf(needle2) === -1) return false;
      var span = document.createElement('span');
      span.textContent = '📎 ' + doc.fileName;
      span.style.cssText = 'cursor:pointer;text-decoration:underline;font-weight:600;';
      span.addEventListener('click', function(e) {
        e.stopPropagation();
        if (window.ReactNativeWebView) {
          window.ReactNativeWebView.postMessage(
            JSON.stringify({ __wherebyDocumentClick: true, doc: doc })
          );
        }
      });
      if (n.parentNode) n.parentNode.replaceChild(span, n);
      return true;
    }

    if (root.nodeType === 3) { replaceNode(root); return; }
    var walker = document.createTreeWalker(root, 4 /* SHOW_TEXT */);
    var n;
    while ((n = walker.nextNode())) { if (replaceNode(n)) break; }
  }

  function processNode(node, text) {
    if (!text || text.indexOf('"type"') === -1) return;
    var doc = extractDocumentJson(text);
    if (!doc) return;
    if (!seenIds.has(doc.documentId)) {
      seenIds.add(doc.documentId);
      if (window.ReactNativeWebView) {
        window.ReactNativeWebView.postMessage(
          JSON.stringify({ __wherebyDomChat: true, text: text, doc: doc })
        );
      }
    }
    // Always replace the raw JSON text in the DOM (also handles re-renders)
    replaceJsonTextInNode(node, doc);
  }

  function scanNode(node) {
    if (node.nodeType === 3) { processNode(node, (node.textContent || '').trim()); return; }
    if (node.nodeType !== 1) return;
    processNode(node, (node.innerText || node.textContent || '').trim());
  }

  var observer = new MutationObserver(function(mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var m = mutations[i];
      for (var j = 0; j < m.addedNodes.length; j++) scanNode(m.addedNodes[j]);
      if (m.type === 'characterData') processNode(m.target, (m.target.textContent || '').trim());
    }
    patchWherebyUi(document.body);
  });

  function start() {
    patchWherebyUi(document.body);
    observer.observe(document.body, { childList: true, subtree: true, characterData: true });
  }
  if (document.body) { start(); }
  else { document.addEventListener('DOMContentLoaded', start); }

  true;
})();
`;
